module.exports = {
    returnName: {
        1: 'ListaCriada',
        2: 'UploadIniciado',
        3: 'UploadFinalizado',
        4: 'EmEsperaParaValidacao',
        5: 'EmProcessamento',
        6: 'EmProcessamento_LeituraDoArquivo',
        7: 'EmProcessamento_RecuperandoInformacaoProgress',
        8: 'EmProcessamento_ValidacaoDoArquivo',
        9: 'EmProcessamento_ExecucaoDoArquivo',
        10: 'ProcessamentoFinalizado',
        11: 'ListaAntiga',
        12: 'ErroExecucao',
        13: 'EmEsperaParaProcessamento',
    },

    returnNameFormatted: {
        1: 'Lista criada',
        2: 'Upload iniciado',
        3: 'Upload finalizado',
        4: 'Em Espera para validação',
        5: 'Em validação',
        6: 'Em validação: Leitura do arquivo',
        7: 'Em validação: Recuperando informação progress',
        8: 'Em validação: Validação do arquivo',
        9: 'Em validação: Execução do arquivo',
        10: 'Validação finalizada',
        11: 'Lista Antiga',
        12: 'Erro na validação da Lista',
        13: 'Em Espera: Enviado para Processamento',
    },
    returnId: {
        ListaCriada: 1,
        UploadIniciado: 2,
        UploadFinalizado: 3,
        EmEsperaParaValidacao: 4,
        EmProcessamento: 5,
        EmProcessamento_LeituraDoArquivo: 6,
        EmProcessamento_RecuperandoInformacaoProgress: 7,
        EmProcessamento_ValidacaoDoArquivo: 8,
        EmProcessamento_ExecucaoDoArquivo: 9,
        ProcessamentoFinalizado: 10,
        ListaAntiga: 11,
        ErroExecucao: 12,
        EmEsperaParaProcessamento: 13,
    },
};
